import React, { useState } from "react";
import { useAuthState, useSignOut } from "react-firebase-hooks/auth";
import { NavLink, useNavigate } from "react-router-dom";
import auth from "../../../FirebaseInit/FirebaseInit";
import Loading from "../../Shear/Loading/Loading";
import profileIMG from "../../../Assets/Images/Image/dashboard/profile.png";
import { useQuery } from "react-query";

const UserMenuItems = () => {
  const [active, setActive] = useState(1);
  const [signOut, loading] = useSignOut(auth);

  let navigate = useNavigate();

  const [user, PLoading] = useAuthState(auth);

  const { data, isLoading, refetch } = useQuery(["single-user", user], () =>
    fetch(`https://itghar-back.onrender.com/single-user?email=${user?.email}`, {
      method: "GET",
      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    }).then((res) => {
      if (res.status === 401 || res.status === 403) {
        navigate("/");
        signOut(auth);
      }

      return res.json();
    })
  );
  console.log(data);
  if (isLoading || loading || PLoading) {
    return <Loading />;
  }

  const signOutHandler = () => {
    localStorage.removeItem("accessToken");
    signOut();
  };

  return (
    <div className="slider_wrapper">
      <div>
        <div className="flex justify-center items-center flex-col">
          <img
            className="w-[64px] h-[64px] mx-auto rounded-full "
            src={data?.image ? data?.image || data.data.image : profileIMG}
            alt="IT Ghar"
          />
          <div>
            <h3 className="text-[17px] mt-2 font-fira font-semibold">
              {data?.name}
            </h3>
          </div>
        </div>
        <div className="pt-5 flex flex-col">
          <NavLink to="/dashboard">
            <button
              onClick={() => setActive(1)}
              className={` text-lg  ${
                active === 1 && "dashboard_menu_items_active"
              } font-bold text-[#1d1d1d] mt-5`}
            >
              <i className="fa-solid fa-user mr-5"></i>
              My Profile
            </button>
          </NavLink>
          <NavLink to="/dashboard/class">
            <button
              onClick={() => setActive(2)}
              className={` text-lg  ${
                active === 2 && "dashboard_menu_items_active"
              } font-bold text-[#1d1d1d] mt-5`}
            >
              <i className="fa-solid fa-user mr-5"></i>
              My Classes
            </button>
          </NavLink>
          {/* 
          <NavLink to="/dashboard/my_order">
            <button
              onClick={() => setActive(3)}
              className={` text-lg  ${
                active === 3 && "dashboard_menu_items_active"
              } font-bold text-[#1d1d1d] mt-5`}
            >
              <i className="fa-solid fa-house-chimney mr-5"></i>
              My Order
            </button>
          </NavLink> */}
          <NavLink to="/dashboard/add_feedback">
            <button
              onClick={() => setActive(4)}
              className={` text-lg  ${
                active === 4 && "dashboard_menu_items_active"
              } font-bold text-[#1d1d1d] mt-5`}
            >
              <i className="fa-solid fa-chart-simple mr-5"></i>
              Add Feedback
            </button>
          </NavLink>
          <NavLink to="/dashboard">
            <button
              onClick={() => setActive(5)}
              className={` text-lg  ${
                active === 5 && "dashboard_menu_items_active"
              } font-bold text-[#1d1d1d] mt-5`}
            >
              <i className="fa-solid fa-gear mr-5"></i>
              Setting
            </button>
          </NavLink>
          <button
            onClick={signOutHandler}
            className="custom_button w-full mt-10 block max-xl:hidden"
          >
            Sign Out{" "}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserMenuItems;
